$(function(){
async function updateCartDrawer() {
  const res = await fetch("/?section_id=c-cart-popup");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  $('.u_cart_drawer').html(newBox)
  // document.querySelector(".u_cart_drawer").innerHTML = newBox;
  console.log('fgewf',newBox)
}
  if($(window).width() > 990){
      $(document).on('click','.my_account',function(e){
        // e.preventDefault()
        $('.u_navbar_account').toggleClass('u_cart_open')
    console.log('efefef')
        updateCartDrawer();
      
        setTimeout(function(){
          $('.u_cart_spinner_block').hide()          
        },1000)
    })
  $("body").click(function(e){
    console.log('body click')
           $(".u_navbar_account").removeClass("u_cart_open"); 
       $('.u_cart_spinner_block').show()
  });

  $('.u_navbar_account').click(function(e){
    console.log('stop propagation')
    e.stopPropagation();
  })
  }
  else{
     $(document).on('click','.my_account',function(e){
    location.href="/cart"
     })
  }
})